'use client';

import dynamic from 'next/dynamic';

export const DynamicChatbot = dynamic(() => import('./ChatBot.client').then((mod) => mod.ChatBot), {
  ssr: false,
  loading: () => null,
});
